import * as React from "react";

function SvgMode(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36.4 31.6"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M36.4 0L18.2 10.5 0 0v31.6l9.1-5.3V15.8l9.1 5.3 9.1-5.3v10.5l9.1 5.3V0z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#37b067"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMode);
